
export const HEIGHT_UNITS = [
    { label: 'Metros (m)', value: 'm' },
    { label: 'Centímetros (cm)', value: 'cm' }
];

export const PENSION_OPTIONS = [
    { label: 'SI', value: 'SI' }, 
    { label: 'NO', value: 'NO' }
];


export const MOCK_CATEGORIAS_EDU = [
    { label: 'Primaria', value: 'PRIMARIA' },
    { label: 'Secundaria', value: 'SECUNDARIA' },
    { label: 'Universidad', value: 'UNIVERSIDAD' },
    { label: 'Postgrado', value: 'POSTGRADO' }
];

export const MOCK_CATEGORIAS_DOCS = [
    { label: 'Certificado', value: 'CERTIFICADO' },
    { label: 'Licencia', value: 'LICENCIA' },
    { label: 'Otro', value: 'OTRO' }
];

export const MOCK_TIPO_HISTORIAL = [
    { label: 'Poligrafía', value: 'POLIGRAFIA' },
    { label: 'Entrevista', value: 'ENTREVISTA' }
];


export const MOCK_PHONE_TYPES = [
    { label: 'Celular', value: 'CELULAR' },
    { label: 'Convencional', value: 'CONVENCIONAL' }
];

export const MOCK_EDUCATION = [
    { categoria: 'Universidad', institucion: 'Universidad Central', descripcion: 'Ingeniería', inicio: '2015-01-01', fin: '2020-01-01' }
];